


































































import mixins from 'vue-typed-mixins'
import MessageMixin from '@/mixins/MessageMixin'

const MAX_TEMPLATE_NUM = 20

export default mixins(MessageMixin).extend({
  name: 'MailTemplate',
  data() {
    const arr = new Array(MAX_TEMPLATE_NUM).fill(false)

    return {
      mode: 'select',
      openCollapses: arr
    }
  },
  computed: {
    userId(): string {
      return this.$store.getters['Chat/userId']
    },

    templates(): any {
      return this.$store.getters['MessageTemplate/templates']
    },

    /**
     * テンプレート登録数が限界
     */
    isLimit(): boolean {
      return Object.keys(this.templates).length >= MAX_TEMPLATE_NUM
    },

    /**
     * テンプレートへ編集の URL
     */
    templateEditURI(): string {
      return `/message/template/edit`
    },

    /**
     * 自動入力の対象か
     */
    autoInputIndex(): number {
      return this.$store.getters['MessageTemplate/autoInputIndex']
    }
  },
  created() {
    this.$store.dispatch('MessageTemplate/fetchTemplates')
  },
  methods: {
    /**
     * 作成クリック
     */
    handleCreateClick() {
      if (this.isLimit) {
        this.$_alert(
          'テンプレート数が20件です。登録済みのものを編集するか不要なものを削除してください。'
        )
        return
      }

      this.$router.push(this.templateEditURI)
    },

    /**
     * 自動入力設定
     */
    async handleAutoInputClick(id: string, index: number) {
      let message = '自動入力を設定しました'
      if (index === this.autoInputIndex) {
        index = -1
        message = '自動入力を解除しました'
      }
      const data = await this.$store.dispatch('MessageTemplate/autoInput', { id })
      if (data.error) {
        this.$_alert('自動入力設定失敗')
        console.error(data.error)
        return
      }
      this.$store.commit('MessageTemplate/setAutoInputIndex', index)

      // 自動入力設定を切り替えたならキャッシュしていた入力途中のテキストをクリア
      this.$_saveInputtingTexts(this.userId, '')

      this.$_alert(message)
    },

    /**
     * 編集
     */
    handleEditClick(template, template_id) {
      this.$router.push({
        name: 'mtemplate_edit',
        params: {
          template,
          template_id
        }
      })
    },

    /**
     * 入力
     */
    handleInputClick(template) {
      this.$router.replace({
        name: 'chat',
        params: {
          id: this.userId,
          template: template.body
        }
      })
    }
  }
})
